// extracted by mini-css-extract-plugin
export default {"container":"AdditionalInfo_container__dGooP","field":"AdditionalInfo_field__EyQSL","value":"AdditionalInfo_value__Aitzu"};